module.exports = __webpack_public_path__ + "img/Patch8-1.1a6c51b1.webp";